export function buildCollectionSearchFilters(query = '') {
  const trimmedQuery = query.trim();

  if (!trimmedQuery) {
    return {};
  }

  return {
    'filters[$or][0][Name][$containsi]': trimmedQuery,
    'filters[$or][1][kind][Name][$containsi]': trimmedQuery,
    'filters[$or][2][manufacturer][Name][$containsi]': trimmedQuery,
    'filters[$or][3][Procesor][$containsi]': trimmedQuery,
    'filters[$or][4][RokProdukcji][$containsi]': trimmedQuery,
  };
}

export function buildRelationFilters(relationName, selectedIds = []) {
  return selectedIds.reduce((filters, id, index) => ({
    ...filters,
    [`filters[${relationName}][id][$in][${index}]`]: id,
  }), {});
}

export function getActiveCatalogFilterCount(query = '', selectedKinds = [], selectedManufacturers = []) {
  const searchCount = query.trim() ? 1 : 0;

  return searchCount + selectedKinds.length + selectedManufacturers.length;
}
